// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventSummary/styles.css
// module id = 397
// module chunks = 0